import { render, staticRenderFns } from "./CreatePromotions.vue?vue&type=template&id=524428f7&scoped=true&"
import script from "./CreatePromotions.vue?vue&type=script&lang=js&"
export * from "./CreatePromotions.vue?vue&type=script&lang=js&"
import style0 from "./CreatePromotions.vue?vue&type=style&index=0&id=524428f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524428f7",
  null
  
)

export default component.exports